import { Grid } from "@mui/material";
import {
  CmpCheckboxField,
  CmpRadioButton,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";

export default function WmsContent({
  selectedOption,
  DetailReportRadioBtn,
  fSuppierWise,
  fBrandWise,
  fItemWise,
  sBufferObj,
}) {
  return (
    <form className="" id="DcRebateDetailReportContent">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"Report Type"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="DETAIL"
                label="Document Type"
                checked={selectedOption === "DETAIL"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpRadioButton
                value="SUPPLIERWISE"
                label="Supplierwise"
                checked={selectedOption === "SUPPLIERWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              md={8}
              sx={{
                "& .MuiFormGroup-root": {
                  textAlign: "left",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                },
              }}
            >
              <CmpCheckboxField
                xChecked={sBufferObj.sDetailSuppierWise === "Y"}
                xOnChange={fSuppierWise}
                xDisabled={false}
                xName={"SUPPLIERWISEPIVOT"}
                xNameField={"Pivot"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpRadioButton
                value="BRANDWISE"
                label="Brandwise"
                checked={selectedOption === "BRANDWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              md={8}
              sx={{
                "& .MuiFormGroup-root": {
                  textAlign: "left",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                },
              }}
            >
              <CmpCheckboxField
                xChecked={sBufferObj.sDetailBrandWise === "Y"}
                xOnChange={fBrandWise}
                xDisabled={false}
                xName={"BRANDWISEPIVOT"}
                xNameField={"Pivot"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CmpRadioButton
                value="BRANCHWISE"
                label="Branchwise"
                checked={selectedOption === "BRANCHWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
              <CmpRadioButton
                value="ITEMWISE"
                label="ItemWise"
                checked={selectedOption === "ITEMWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={8}
              sm={8}
              md={8}
              sx={{
                "& .MuiFormGroup-root": {
                  textAlign: "left",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                },
              }}
            >
              <CmpCheckboxField
                xChecked={sBufferObj.sDetailItemWise === "Y"}
                xOnChange={fItemWise}
                xDisabled={false}
                xName={"ITEMWISEPIVOT"}
                xNameField={"Pivot"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
